import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";
import {confirmAlert} from "react-confirm-alert";

/**
 *  @property {Accounts_Ip_Whitelists_Object} state
 *  @property {object} model
 *  @property {Accounts_Ip_Whitelists_Properties} model.properties
 *  @property {Accounts_Ip_Whitelists_Is} model.is
 *  @property {Accounts_Ip_Whitelists_Has} model.has
 */
export default class IpWhitelists extends ObjectOverride {
	constructor(props) {
		super(props, Types.Accounts_Ip_Whitelists._name);
	}

	normalizeIpAddress = (ipAddress) => {
		return `${ipAddress || ''}`.trim();
	};

	getCurrentClientIp = async () => {
		let accountModel = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);

		try {
			const response = await accountModel.submit(null, 'GET_CURRENT_IP', true);
			return this.normalizeIpAddress(response.current_client_ip);
		} catch (error) {
			return '';
		}
	};

	confirmIpMismatchWarning = (title, enteredIpAddress, currentIpAddress) => new Promise((resolve) => {
		confirmAlert({
			title,
			message: (
				<div className="alert alert-danger" style={{marginBottom: 0}}>
					<p>
						The IP address you entered does not match your current connection IP address.
					</p>
					<p>
						Current IP: <strong>{currentIpAddress}</strong><br/>
						Entered IP: <strong>{enteredIpAddress}</strong>
					</p>
					<p>
						If you continue, you will lose access to your account from this connection.
						Restoring access requires contacting support and may incur a $200 reinstatement fee.
					</p>
				</div>
			),
			buttons: [
				{
					label: 'OK',
					onClick: () => resolve(true)
				},
				{
					label: 'Cancel',
					onClick: () => resolve(false)
				}
			]
		});
	});

	showCurrentIpUnavailableWarning = () => {
		confirmAlert({
			title: 'Current IP Required',
			message: (
				<div className="alert alert-danger" style={{marginBottom: 0}}>
					FFL Boss could not verify your current IP address. The whitelist IP was not added.
					Please try again before creating a whitelist rule.
				</div>
			),
			buttons: [
				{
					label: 'OK',
					onClick: () => {}
				}
			]
		});
	};

	handleSubmit = async (event, suppressToast = false, suppressProcess = false) => {
		if (typeof event !== 'undefined' && event !== null) event.preventDefault();

		const enteredIpAddress = this.normalizeIpAddress(this.state.ip_address);
		const currentIpAddress = await this.getCurrentClientIp();

		if (enteredIpAddress && !currentIpAddress) {
			this.showCurrentIpUnavailableWarning();
			return false;
		}

		if (enteredIpAddress && currentIpAddress && enteredIpAddress !== currentIpAddress) {
			const firstWarningAccepted = await this.confirmIpMismatchWarning('Warning', enteredIpAddress, currentIpAddress);
			if (!firstWarningAccepted) {
				return false;
			}

			const secondWarningAccepted = await this.confirmIpMismatchWarning('Final Warning', enteredIpAddress, currentIpAddress);
			if (!secondWarningAccepted) {
				return false;
			}
		}

		return super.handleSubmit(null, suppressToast, suppressProcess);
	};

	form = () => {
		/** @type {Accounts_Ip_Whitelists_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Ip_Whitelists_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">IP Whitelist</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"IP To Whitelist"}
									value={object.ip_address}
									error={object.ip_address_error}
									property={properties.ip_address}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
